import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L, { LatLngExpression } from 'leaflet';
import Icons from 'core/data/constants/Icons';
import { renderToStaticMarkup } from 'react-dom/server';

import { useTranslation } from 'react-i18next';
function Map() {
    const { t } = useTranslation();
    const defaultCenter: LatLngExpression = [38.65577869239144, -9.062723462468671];
    const svgHtml = renderToStaticMarkup(
        <Icons.MapMarker fill="#049dd9" />
    );

    const icon = L.divIcon({
        html: svgHtml,
        className: 'svg-marker',
        iconSize: [32, 32],
        iconAnchor: [16, 32],
    });
    return (
        <MapContainer
            center={defaultCenter}
            zoom={15}
            style={{ height: '400px', width: '100%' }}
        >
            <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution="© OpenStreetMap contributors"
            />
            <Marker position={defaultCenter} icon={icon}>
                <Popup>
                    {t("ironing_sara")}
                </Popup>
            </Marker>
        </MapContainer>
    );
}

export default Map;

